import { Props, SessionContext } from './Session.provider'

import React from 'react'

const useSession = (): Props => {
	const context = React.useContext(SessionContext)
	if (context === undefined) {
		throw new Error('useSession must be used within a SessionProvider')
	}
	return context
}

export default useSession
